import React from "react";
import styled from "styled-components";

const Square = styled.div`
  width: 60px;
  height: 60px;
  background-color: #4e6bff;
  box-shadow: 10px 10px 5px #c4c4c4;
  opacity: 0.7;
  position: absolute;
  top: -60px;
  left: -60px;
  z-index: -1;
  animation: square 15s linear alternate infinite;
  @keyframes square {
    to {
      transform: translate(100vw, 100vh) rotate(360deg);
    }
  }
`;

const Circle = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #ff97af;
  box-shadow: 10px 10px 5px #c4c4c4;
  position: absolute;
  top: 400px;
  left: -100px;
  z-index: -1;
  animation: circle 18s linear alternate infinite;
  @keyframes circle {
    to {
      transform: translate(100vw, -100vh);
    }
  }
`;

const Rect = styled.div`
  width: 50px;
  height: 100px;
  background-color: #669966;
  box-shadow: 10px 10px 5px #c4c4c4;
  opacity: 0.5;
  position: absolute;
  top: 700px;
  left: -50px;
  z-index: -1;
  animation: rect 11s linear alternate infinite;
  @keyframes rect {
    to {
      transform: translate(100vw, -50vh) rotate(180deg);
    }
  }
`;

const ShapesAnimated = () => {
  return (
    <>
      <Square />
      <Circle />
      <Rect />
    </>
  );
};

export default ShapesAnimated;
